template = require('./tooltip.html.slim')

angular.module('wbComponents').directive 'wbTooltip',
[  ->
  restrict: 'E'
  replace: true
  transclude: true
  scope: true

  templateUrl: template

  link: ($scope, $el, $attrs) ->
    $scope.tooltipClose = ->
      $el.removeClass('active')
      return

    $scope.tooltipToggle = ->
      $el.toggleClass('active')
      return

    $('html').click (e) ->
      return if $.contains($el[0], e.target)
      $el.removeClass('active')
      return

    setDirection = ->
      windowHalf = angular.element(window).width() / 2
      toolTipOffset = $el.prop 'offsetLeft'
      if toolTipOffset > windowHalf
        $el.removeClass('tooltip-right').addClass('tooltip-left')
      else
        $el.removeClass('tooltip-left').addClass('tooltip-right');

    angular.element(window).on 'resize', _.debounce ->
      setDirection()
    , 500

    setDirection()
]
